import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { Box } from '@mui/material'
import { ProductSettingsTable } from 'Features/Projects/Scenarios/EditSettings/LineSettings/ProductSettings/ProductSettings.Table'
import { useWindowSize } from 'Common/hooks/useWindowSize.hook'
import { max } from 'lodash'
import { useBatchSettings, useProductSettings } from '../LineSettings.data'
import { Loader } from 'Common/Loader/Loader'
import { useParams } from 'react-router-dom'
import { EditSettingsDataFilter } from '../../EditSettings.DataFilter'
import { useSettingsContext } from '../../EditSettings.types'
import { useMemo } from 'react'

export const ProductSettingsView = () => {
  const { projectId, scenarioId } = useParams() as {
    projectId: string
    scenarioId: string
  }

  const { view_width } = useWindowSize()
  const { state } = useSettingsContext()
  const { selectedBaseSourceSite, selectedWorkCentre } = state

  const { data: productSettings, isLoading: isProductLoading } =
    useProductSettings({
      projectId,
      scenarioId,
    })
  const { data: batchData, isLoading: isBatchLoading } = useBatchSettings({
    projectId,
    scenarioId,
  })

  const filteredProductSettings = useMemo(() => {
    if (!productSettings) return []
    
    let filtered = productSettings
    
    // Filter by baseSourceSite
    if (selectedBaseSourceSite && selectedBaseSourceSite !== 'All') {
      filtered = filtered.filter(
        (item) => item.baseSourceSiteCode === selectedBaseSourceSite
      )
    }
    
    // Filter by workCentre  
    if (selectedWorkCentre && selectedWorkCentre !== 'All') {
      filtered = filtered.filter(
        (item) => item.workcentreCode === selectedWorkCentre
      )
    }
    
    return filtered
  }, [productSettings, selectedBaseSourceSite, selectedWorkCentre])

  const isLoading = isProductLoading || isBatchLoading

  return (
    <Page>
      <Box
        sx={{
          display: 'flex',
          flex: 'auto',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          width: max([view_width, 1500]),
        }}
      >
        <PageHeader
          title="SKU Production"
          rightElement={<EditSettingsDataFilter />}
        />
        <Box sx={{ flex: 1, minHeight: 0 }}>
          {isLoading ? (
            <Loader />
          ) : (
            <ProductSettingsTable
              data={filteredProductSettings}
              batchData={batchData ?? []}
              isLoading={isLoading}
            />
          )}
        </Box>
      </Box>
    </Page>
  )
}
